module.exports = __webpack_public_path__ + "static/img/loginL.74cb7b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/main/loginL.png
// module id = kC+e
// module chunks = 26